import { Controller } from '@hotwired/stimulus'
import { storageGet, storageSet } from '../../helpers'

export default class extends Controller {
  static targets = ['toggle', 'censorable', 'iconVisible', 'iconHidden']
  static values = { storageKey: String }

  connect() {
    this.restoreVisibility()
  }

  toggle(event) {
    const columnKey = event.currentTarget.dataset.column
    if (!columnKey) return

    this.toggleColumn(columnKey)
  }

  toggleColumn(columnKey) {
    const censorables = this.censorableTargets.filter(el => el.dataset.column === columnKey)
    if (censorables.length === 0) return

    const isCurrentlyVisible = !censorables[0].classList.contains('censored')
    this.setColumnVisibility(columnKey, !isCurrentlyVisible)
    this.saveVisibility()
  }

  setColumnVisibility(columnKey, isVisible) {
    this.censorableTargets
      .filter(el => el.dataset.column === columnKey)
      .forEach(el => {
        el.classList.toggle('censored', !isVisible)
        if (isVisible) {
          el.removeAttribute('aria-hidden')
        } else {
          el.setAttribute('aria-hidden', 'true')
        }
      })

    this.updateToggleIcon(columnKey, isVisible)
  }

  updateToggleIcon(columnKey, isVisible) {
    const toggle = this.toggleTargets.find(t => t.dataset.column === columnKey)
    if (!toggle) return

    const iconVisible = toggle.querySelector('[data-table--column-visibility-target="iconVisible"]')
    const iconHidden = toggle.querySelector('[data-table--column-visibility-target="iconHidden"]')

    if (iconVisible && iconHidden) {
      iconVisible.classList.toggle('hidden', !isVisible)
      iconHidden.classList.toggle('hidden', isVisible)
    }
  }

  restoreVisibility() {
    if (!this.storageKeyValue) return

    const visibility = storageGet(this.storageKeyValue)
    if (!visibility) return

    Object.entries(visibility).forEach(([key, isVisible]) => {
      this.setColumnVisibility(key, isVisible)
    })
  }

  saveVisibility() {
    if (!this.storageKeyValue) return

    const visibility = {}
    const seenColumns = new Set()

    this.censorableTargets.forEach(col => {
      const key = col.dataset.column
      if (key && !seenColumns.has(key)) {
        seenColumns.add(key)
        visibility[key] = !col.classList.contains('censored')
      }
    })

    storageSet(this.storageKeyValue, visibility)
  }
}
